export const Cursors = {
  PointerCancelRed: "url('/pointer-cancel-red.svg'), auto",
  PointerBoltGreen: "url('/pointer-bolt-green.svg'), auto",
}
